export enum ValidationMessageKey {
    Digits = 'digits',
    Email = 'email',
    EmailAlreadyExist = 'emailAlreadyExist',
    Maxlength = 'maxlength',
    MinActiveUsers = 'minActiveUsers',
    MinLength = 'minlength',
    NgbDate = 'ngbDate',
    PasswordsMismatch = 'passwordsMismatch',
    WeakPassword = 'weakPassword',
    Pattern = 'pattern',
    Required = 'required',
    WrongPasswordOrUsername = 'wrongPasswordOrUsername'
}
